import http from "./http-common";

class ReplyerService {
  async getAll() {    
   const respons= await http.get(`Replyer/GetAll`);   
    return respons
  }  
}

export default new ReplyerService();